// src/hooks/useTopicRefiner.ts — loader for the owner console's Topic refiner
// panel (1.24.00 B4): `GET /owner/topic-refiner/`. Same shape as every other
// owner aggregate loader ({data, loading, error, refetch}); the section calls
// refetch after each write so the counters and the switch state are the
// server's, never an optimistic guess.
import { ownerService } from '@/core/services/ownerService';
import { useOwnerList } from './useOwnerList';
import type { TopicRefinerState } from '@/core/models';

export function useTopicRefiner() {
  return useOwnerList<TopicRefinerState>(() => ownerService.getTopicRefiner());
}
